"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    NativeToolbarMenu: null,
    NativeToolbarMenuAction: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NativeToolbarMenu () {
        return NativeToolbarMenu;
    },
    get NativeToolbarMenuAction () {
        return NativeToolbarMenuAction;
    }
});
const NativeToolbarMenu = ()=>null;
const NativeToolbarMenuAction = ()=>null;

//# sourceMappingURL=native.js.map
